import { useState } from 'react';
import MetaTags from 'react-meta-tags';
import Login from '../components/Login';

// TODO: Move to DB
const quips = [
  "Trivia is the best revenge.",
  "I think, therefore I trivia.",
  "Trivia, my dear Watson.",
  "In the beginning, there was trivia.",
  "Ask not what trivia can do for you, ask what you can do for trivia.",
  "The unexamined trivia is not worth knowing.",
  "To trivia or not to trivia, that is the question.",
  "All trivia's a stage, and all the men and women merely players.",
  "Trivia is what happens when you're busy making other plans.",
  "Trivia does not simply walk into Mordor.",
  "Trivia has a way of changing everything.",
  "Trivia is the spice of life.",
  "I love the smell of trivia in the morning.",
  "Keep calm and trivia on.",
  "May the trivia be with you.",
  "Trivia, my dear Watson.",
  "To trivia or not to trivia, that is the question.",
  "You had me at trivia.",
  "Trivia, for lack of a better word, is good.",
  "Houston, we have trivia.",
  "Trivia is like a box of chocolates.",
  "There's no place like trivia.",
  "Keep your friends close, but your trivia closer.",
  "Say 'hello' to my little trivia!",
  "Here's looking at you, trivia.",
  "Nobody puts trivia in a corner.",
  "May you live all the days of your life filled with trivia.",
  "Mama always said trivia is as trivia does.",
  "When life gives you trivia, make lemonade.",
  "There's no crying in trivia!",
  "I feel the need, the need for trivia.",
  "Keep your friends close, but your trivia closer.",
  "I'll have what trivia's having.",
  "A day without trivia is like a day without sunshine.",
  "They may take our lives, but they'll never take our trivia!"
];

/**
 * Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Home = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [quip, setQuip] = useState(quips[Math.floor(Math.random() * quips.length)]);

  const player = JSON.parse(localStorage.getItem('player'));

  /**
   * onPlayClick
   *
   * Handler for when the play button is clicked. Redirects to the dashboard if the player is logged in, otherwise
   * redirects to the subjects page.
   */
  const onPlayClick = () => {
    if (player) {
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/subjects';
    }
  }

  return (
    <div>
      <MetaTags>
        <link rel="preload" as="image" href="/logo_top_icon.png"/>
      </MetaTags>
      <div className="home-page">
        <div className="logo-wrap">
          <img fetchpriority="high" src="/logo_top_icon.png" className="home-logo" alt="logo"/>
          <div className="trade-mark-home">&trade;</div>
          <h1 className="logo-text">Daily Multiplayer Trivia</h1>
          {/*<h2 className="powered-by-text">Powered by the most advanced AI on the planet.</h2>*/}
        </div>

        <div className="home-slogan">{quip}</div>

        <button className="main-btn play-button" onClick={onPlayClick}>Play</button>
        {(!player?.email && !player?.temp_id) &&
          <div>
            {!showLogin &&
              <button className="main-btn" onClick={() => setShowLogin(true)}>Login</button>
            }
            {showLogin &&
              <Login/>
            }
          </div>
        }
        {/*<div>*/}
        {/*  <div className="preview-title">PREVIEW</div>*/}
        {/*  <div className="preview-text">This is a preview version. Still a few bugs to work out. Feel free to play but*/}
        {/*    you may experience some weirdness and your games might disappear.*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      <div className="copyright-home">&copy; 2024 Jim McGowen</div>
    </div>
  );
}

export default Home;
